import React from "react";
import { ColorIconProps, getColorIconSize } from "./utils";

const AskPaperIcon: React.FC<ColorIconProps> = ({
  size = "default",
  className,
}) => {
  return (
    <svg
      width={getColorIconSize(size)}
      height={getColorIconSize(size)}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.28256 1.6637L14.3196 1.6637L17.5029 4.84275V14.5832H7.28256V1.6637Z"
        fill="var(--cdl-bg-subtle)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.45218 1.66375C6.45218 1.20515 6.82395 0.833374 7.28256 0.833374H14.3196C14.5396 0.833374 14.7507 0.920706 14.9064 1.07619L18.0897 4.25525C18.2457 4.411 18.3333 4.62238 18.3333 4.84281V14.5833C18.3333 15.0419 17.9615 15.4137 17.5029 15.4137H7.28256C6.82395 15.4137 6.45218 15.0419 6.45218 14.5833V1.66375ZM8.11294 2.49413V13.7529H16.6726V5.18709L13.976 2.49413H8.11294Z"
        fill="var(--cdl-bg-subtle)"
      />
      <path
        d="M2.49704 10.464V9.49597L13.1489 9.49597C13.1489 9.49597 13.1489 9.83291 13.1489 10.464C13.1489 13.4054 10.7644 15.79 7.82297 15.79C4.88154 15.79 2.49704 13.4054 2.49704 10.464Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.49704 8.66553L13.1489 8.66553C13.3691 8.66553 13.5803 8.75301 13.7361 8.90874C13.8918 9.06447 13.9793 9.27568 13.9793 9.49591V10.464C13.9793 13.864 11.223 16.6203 7.82297 16.6203C4.42293 16.6203 1.66666 13.864 1.66666 10.464V9.49591C1.66666 9.0373 2.03843 8.66553 2.49704 8.66553ZM3.32741 10.3263V10.464C3.32741 12.9468 5.34014 14.9595 7.82297 14.9595C10.3058 14.9595 12.3185 12.9468 12.3185 10.464V10.3263L3.32741 10.3263Z"
        fill="currentColor"
      />
      <path
        d="M2.49701 9.47828C2.49701 6.53685 4.88151 4.15234 7.82294 4.15234C10.7644 4.15234 13.1489 6.53685 13.1489 9.47828C13.1489 12.4197 10.7644 14.8042 7.82294 14.8042C4.88151 14.8042 2.49701 12.4197 2.49701 9.47828Z"
        fill="var(--cdl-bg-subtle)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.66666 9.47821C1.66666 6.07817 4.42293 3.3219 7.82297 3.3219C11.223 3.3219 13.9793 6.07817 13.9793 9.47821C13.9793 12.8782 11.223 15.6345 7.82297 15.6345C4.42293 15.6345 1.66666 12.8782 1.66666 9.47821ZM7.82297 4.98266C5.34014 4.98266 3.32741 6.99539 3.32741 9.47821C3.32741 11.961 5.34014 13.9738 7.82297 13.9738C10.3058 13.9738 12.3185 11.961 12.3185 9.47821C12.3185 6.99539 10.3058 4.98266 7.82297 4.98266Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1277 13.3428C11.452 13.0185 11.9778 13.0185 12.3021 13.3428L16.0218 17.0625C16.3461 17.3868 16.3461 17.9126 16.0218 18.2369C15.6975 18.5612 15.1717 18.5612 14.8474 18.2369L11.1277 14.5172C10.8035 14.1929 10.8035 13.6671 11.1277 13.3428Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default AskPaperIcon;
